"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Okurigana = {
    elemName: '送り仮名',
    type: 'inline',
    doc: '漢文の送り仮名をマークアップします。',
    example: '￣オクリガナ',
    minContentCount: 1,
    maxContentCount: 1,
    textTemplate: '￣{{$1}}',
    htmlTemplate: `<span {{{$htmlId}}} class="Okurigana {{$classes}}">{{{$1}}}</span>`,
    xmlTemplate: `<span type="okurigana" {{{$xmlId}}} {{{$xmlSubtypes}}}>{{{$1}}}</span>`,
    docxTemplate: `
			<w:r>
        		<w:rPr>
                    <w:rFonts w:hint="eastAsia"/>
                    <w:vertAlign w:val="superscript"/>
                </w:rPr>
                <w:t>{{{$$1}}}</w:t>
            </w:r>
	`,
    latexTemplate: '\\kokana{ {{{$1}}} }{}'
};
exports.default = Okurigana;
// import { KojiASTNode } from '../../KojiAstBuilder';
// export default class Okurigana extends ConversionRule {
// 	get elemName() {
// 		return '送り仮名';
// 	}
// 	toXML(node: KojiASTNode): string {
// 		// see https://www.jstage.jst.go.jp/article/jsik/28/2/28_2018_017/_pdf
// 		const text = this.convertChildren(node.children);
// 		return `<span type="okurigana" >${text}</span>`;
// 	}
// 	toText(node: KojiASTNode): string {
// 		const text = this.converter.convertChildren(node.children);
// 		return `￣${text}`;
// 	}
// 	toHTML(node: KojiASTNode) {
// 		const text = this.convertChildren(node.children);
// 		return `<span class="Okurigana inline" >${text}</span>`;
// 	}
// }
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT2t1cmlnYW5hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbnZlcnRlci9pbmxpbmVfcnVsZXMvT2t1cmlnYW5hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQ0EsTUFBTSxTQUFTLEdBQW1CO0lBQ2pDLFFBQVEsRUFBRSxNQUFNO0lBQ2hCLElBQUksRUFBRSxRQUFRO0lBQ2QsR0FBRyxFQUFFLG9CQUFvQjtJQUN6QixPQUFPLEVBQUUsUUFBUTtJQUNqQixlQUFlLEVBQUUsQ0FBQztJQUNsQixlQUFlLEVBQUUsQ0FBQztJQUNsQixZQUFZLEVBQUUsU0FBUztJQUN2QixZQUFZLEVBQUUsb0VBQW9FO0lBQ2xGLFdBQVcsRUFBRSx3RUFBd0U7SUFDckYsWUFBWSxFQUFFOzs7Ozs7OztFQVFiO0lBQ0QsYUFBYSxFQUFFLHdCQUF3QjtDQUN2QyxDQUFDO0FBRUYsa0JBQWUsU0FBUyxDQUFDO0FBRXpCLHNEQUFzRDtBQUV0RCwwREFBMEQ7QUFDMUQsb0JBQW9CO0FBQ3BCLG1CQUFtQjtBQUNuQixLQUFLO0FBRUwsc0NBQXNDO0FBQ3RDLDJFQUEyRTtBQUMzRSxzREFBc0Q7QUFDdEQscURBQXFEO0FBQ3JELEtBQUs7QUFFTCx1Q0FBdUM7QUFDdkMsZ0VBQWdFO0FBQ2hFLHVCQUF1QjtBQUN2QixLQUFLO0FBRUwsK0JBQStCO0FBQy9CLHNEQUFzRDtBQUN0RCw2REFBNkQ7QUFDN0QsS0FBSztBQUNMLElBQUkifQ==